import * as S from "./Term.style";

interface TermProps {
  text?: any;
  checkbox?: React.ReactElement;
  processBar?: boolean;
}

export const Term = ({ processBar, text, checkbox }: TermProps) => {
  return (
    <S.TermBox>
      <S.Term $processBar={processBar ? processBar : false}>
        <p>{text}</p>
      </S.Term>
      <S.TermAgree>{checkbox}</S.TermAgree>
    </S.TermBox>
  );
};
